import { Descriptions, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import Header from "shared/components/Header";
import Spin from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";

const STATUS_COLORS = {
  draft: "orange",
  confirmed: "green",
};

const Detail = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, loading } = useQuery(graphql.queries.DOCUMENT_TEMPLATE, {
    variables: { where: { id } },
  });

  if (loading) return <Spin />;

  const template = data?.documentTemplate;
  if (!template) return null;

  return (
    <>
      <Header
        title={`${template.type} — ${template.version}`}
        actions={[
          {
            text: DETAIL.HEADER.BACK,
            onClick: () =>
              navigate(SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path),
            type: "gray--link",
            icon: <BiChevronLeft size={20} />,
          },
        ]}
      />
      <Descriptions bordered column={1} className="dynamic-documents__detail">
        <Descriptions.Item label={DETAIL.TYPE}>
          {template.type}
        </Descriptions.Item>
        <Descriptions.Item label={DETAIL.VERSION}>
          {template.version}
        </Descriptions.Item>
        <Descriptions.Item label={DETAIL.STATUS}>
          <Tag color={STATUS_COLORS[template.status] || "default"}>
            {template.status}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label={DETAIL.S3_KEY}>
          {template.s3Key || DETAIL.NONE}
        </Descriptions.Item>
        <Descriptions.Item label={DETAIL.ANCHORS}>
          {template.anchors?.length > 0
            ? template.anchors.map((anchor) => <Tag key={anchor}>{anchor}</Tag>)
            : DETAIL.NONE}
        </Descriptions.Item>
        <Descriptions.Item label={DETAIL.CREATED_DATE}>
          {template.createdDate
            ? new Date(template.createdDate).toLocaleString(DETAIL.DATE_LOCALE)
            : DETAIL.NONE}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default Detail;
